/**
 * Detect fn
 */
export default () => 'setPrototypeOf' in Object;
